module.exports = __webpack_public_path__ + "media/elevadizo/buque-9dd8ea68.png";